import { matchType } from "../matcher";
import { isNullable } from "../type-guards";
import { jp } from "./error-messages";
export const japanizeZodErrorMap = (issue) => {
    switch (issue.code) {
        case "invalid_type": {
            return isNullable(issue.input)
                ? jp.invalid_type.required
                : jp.invalid_type.default(issue);
        }
        case "too_big": {
            const type = matchType(issue.origin, {
                number: "number",
                int: "number",
                bigint: "number",
                date: "date",
                string: "string",
                array: "collection",
                set: "collection",
                file: "file",
            });
            const operator = issue.inclusive ? "inclusive" : "not_inclusive";
            return jp.too_big[type][operator](issue);
        }
        case "too_small": {
            const type = matchType(issue.origin, {
                number: "number",
                int: "number",
                bigint: "number",
                date: "date",
                string: "string",
                array: "collection",
                set: "collection",
                file: "file",
            });
            const operator = issue.inclusive ? "inclusive" : "not_inclusive";
            return jp.too_small[type][operator](issue);
        }
        case "invalid_format": {
            const _issue = issue;
            switch (_issue.format) {
                case "starts_with":
                    return jp.invalid_format.startsWith(_issue);
                case "ends_with":
                    return jp.invalid_format.endsWith(_issue);
                case "includes":
                    return jp.invalid_format.include(_issue);
                case "regex":
                    return jp.invalid_format.regex(_issue);
                default:
                    return jp.invalid_format.default(_issue);
            }
        }
        case "invalid_value":
            if (issue.values.length === 1)
                return jp.invalid_value.single(issue);
            return jp.invalid_value.multiple(issue);
        case "not_multiple_of":
            return jp.not_multiple_of(issue);
        case "unrecognized_keys":
            return jp.unrecognized_keys(issue);
        case "invalid_key":
            return jp.invalid_key(issue);
        case "invalid_union":
            return jp.invalid_union();
        case "invalid_element":
            return jp.invalid_element(issue);
        default:
            return undefined;
    }
};
//# sourceMappingURL=zod-error-map.js.map